import type { Form } from '../../../common/types/form';
import type { Client } from '../../../common/types/client';

const firstContactForm: Form<Client> = {
  key: 'firstContact',
  title: 'Erstkontakt',
  fields: [
    {
      key: 'firstContactDate',
      label: 'Datum',
      fieldTypes: 'date',
    },
    {
      key: 'firstContactTopic',
      label: 'Thema',
      fieldTypes: 'text',
    },
    {
      key: 'firstContactNote',
      label: 'Notizen zum Erstkontakt',
      fieldTypes: 'textArea',
      rows: 5,
      xsWidth: 12,
    },
  ],
};

export default firstContactForm;
